'use client';

import { TimeMachineService } from '@/services/timemachine.service';
import { MatchModelBase } from '@nf/types/odds';
import clsx from 'clsx';
import { useState, useContext, createContext, useMemo, useEffect } from 'react';
import { timeMachineStyles } from '../time-machine.style'

interface TimeMachineContextType {
	pointValue: number;
	setPointValue: (pointValue: number) => void;
	currentTimeValue: number;
	currentMatchTimeValue: number;
	is2HTemp: boolean;
};

const TimeMachineContext = createContext<TimeMachineContextType>({
	pointValue: 0,
	setPointValue: () => { },
	currentTimeValue: 0,
	currentMatchTimeValue: 0,
	is2HTemp: false,
});

export function TimeMachineProvider({
	children,
	matchModel,
	tmIntervalTime
}: {
	children: React.ReactNode,
	matchModel: MatchModelBase,
	tmIntervalTime: number
}) {
	const [pointValue, setPointValue] = useState(tmIntervalTime);
	const [currentTimeValue, setCurrentTimeValue] = useState(0);
	const [currentMatchTimeValue, setCurrentMatchTimeValue] = useState(0);
	const [is2HTemp, setIs2HTemp] = useState(false);
	const [is4XTemp, setIs4XTemp] = useState(false);

	useEffect(() => {
		const matchTime = TimeMachineService.GetTimeMachineTime(matchModel, tmIntervalTime, true);
		setCurrentMatchTimeValue(matchTime);

		const timeMachineTime = TimeMachineService.GetTimeMachineTime(matchModel, tmIntervalTime);
		setCurrentTimeValue(timeMachineTime);

		const isTwoTemp = timeMachineTime > Number(45 + tmIntervalTime - 1);
		setIs2HTemp(isTwoTemp);

		const isFourTemp = timeMachineTime > 79
		setIs4XTemp(isFourTemp);

		if (timeMachineTime > pointValue) setPointValue(timeMachineTime);
	}, [matchModel]);

	const value = useMemo(() => ({
		pointValue,
		setPointValue,
		currentTimeValue,
		currentMatchTimeValue,
		is2HTemp,
	}), [pointValue, currentTimeValue, currentMatchTimeValue, is2HTemp]);

	return (
		<TimeMachineContext.Provider value={value}>
			<div className={clsx('time-machine', { 'time-machine--2h': is2HTemp }, { 'time-machine--4x': is4XTemp }, timeMachineStyles.timeMachine)}>
				{children}
			</div>
		</TimeMachineContext.Provider>
	);
}

export const useTimeMachine = () => useContext(TimeMachineContext);